<mat-toolbar color="primary">
  <mat-toolbar-row>
    <a href="#">
      <img id="logo" src="/assets/img/logo.png" />
    </a>
    <h1 id="slogan">La qualité de notre engagement ne fait pas un pli</h1>
  </mat-toolbar-row>
</mat-toolbar>

<div id="parent">
  <div id="child">
    <img width=200px src="/assets/pictogrammes/maintenance.svg" />
    <h1>Nous serons bientôt de retour.</h1>
    <p>Nous mettons actuellement à jour l'espace client et nous reviendrons très bientôt. Merci de votre patience.</p>
  </div>
</div>